module.exports = __webpack_public_path__ + "static/media/tamtam.c01db06e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/tamtam.eot?cciqt6
// module id = 169
// module chunks = 0